import {
  GAMES_REQUEST, GAMES_SUCCESS, GAMES_FAILURE
} from '../actions/games'

const INITIAL_STATE = {
  games: null, gamesNeedRefresh: false, error: null, loading: false
}

const gamesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GAMES_REQUEST:
      return {
        ...state,
        gamesNeedRefresh: false, error: null, loading: true
      }
    case GAMES_SUCCESS:
      return {
        ...state,
        gamesNeedRefresh: false, games: action.response, error: null, loading: false
      }
    case GAMES_FAILURE:
      return {
        ...state,
        error: action.error, loading: false
      }
    default:
      return state
  }
}

export default gamesReducer

